import { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { useT } from "@/i18n";
import { usePageMeta } from "@/lib/format";
import { PageHeader } from "@/components/StatCard";
import Seo from "@/components/Seo";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronDown, LifeBuoy, HelpCircle } from "lucide-react";

const FAQ_KEYS = ["getting_started", "payouts", "clients", "pro", "branding", "refunds"];

export default function Help() {
  const { user } = useAuth();
  const t = useT();
  usePageMeta(t("help.meta_title"));
  const [open, setOpen] = useState(null);

  if (user && user.role !== "coach") return <Navigate to="/app/circles" replace />;

  return (
    <div data-testid="coach-help-page">
      <Seo title={t("help.seo")} noindex />
      <Link to="/app/coach" className="mb-3 inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground" data-testid="help-back">
        <ChevronLeft className="h-4 w-4" /> {t("cset.back_dashboard")}
      </Link>
      <PageHeader eyebrow={t("help.eyebrow")} title={t("help.title")} subtitle={t("help.subtitle")} />

      <div className="space-y-2">
        {FAQ_KEYS.map((k) => {
          const isOpen = open === k;
          return (
            <div key={k} className="overflow-hidden rounded-2xl border border-border bg-card" data-testid={`help-faq-${k}`}>
              <button onClick={() => setOpen(isOpen ? null : k)} className="flex w-full items-center gap-3 p-4 text-left" data-testid={`help-faq-toggle-${k}`}>
                <HelpCircle className="h-4 w-4 shrink-0 text-primary" />
                <span className="min-w-0 flex-1 text-sm font-medium text-foreground">{t(`help.q_${k}`)}</span>
                <ChevronDown className={`h-4 w-4 shrink-0 text-muted-foreground transition-transform ${isOpen ? "rotate-180" : ""}`} />
              </button>
              {isOpen && <p className="px-4 pb-4 pl-11 text-sm text-muted-foreground">{t(`help.a_${k}`)}</p>}
            </div>
          );
        })}
      </div>

      <div className="mt-6 flex flex-col items-center gap-3 rounded-2xl border border-primary/30 bg-primary/5 p-6 text-center" data-testid="help-contact">
        <div className="flex h-11 w-11 items-center justify-center rounded-full bg-primary/15 text-primary"><LifeBuoy className="h-5 w-5" /></div>
        <p className="text-sm text-muted-foreground">{t("help.contact_sub")}</p>
        <Link to="/app/coach/support"><Button className="rounded-full" data-testid="help-to-support">{t("help.contact_cta")}</Button></Link>
      </div>
    </div>
  );
}
